import styled from 'styled-components'

import * as colors from "Components/colors"

export const Back = styled.div`
    height: 100%;
    display: flex;
    align-items: center;
    color: ${colors.QuorumBlue};

    &:hover {
        background-color: ${colors.DarkerPorcelain};
        cursor: pointer;
    }
`
